import type { BoxProps } from "@chakra-ui/react";
import { Box, Text, Image, forwardRef } from "@chakra-ui/react";
import React from "react";
import dayjs from "dayjs";
import { observer } from "mobx-react";
import { useStore } from "@/store";
import { translations } from "@/constants/translations";
import { renderInnerHtml } from "@/helpers/dom";

interface Props extends BoxProps {
  traineeName: string;
}

export const TrainingCertificate = forwardRef<Props, "div">(
  ({ traineeName, ...props }, ref) => {
    return (
      <Box
        position="relative"
        ref={ref}
        {...props}
      >
        <Content traineeName={traineeName} />
      </Box>
    );
  },
);

const Content = observer(({ traineeName }: Props) => {
  const currentDateFormatted = dayjs().format("YYYY-MM-DD");
  const { activeLanguage } = useStore();
  const language = translations.pages.training[activeLanguage];

  return (
    <>
      <Image
        display="inline-block"
        src="/images/certificate-template.png"
      />
      <Text
        position="absolute"
        display="inline-block"
        top="38%"
        left="50%"
        transform="translate(-50%, 0);"
        fontSize="clamp(1rem, 3.25cqw, 56px)"
        minWidth="70%"
        fontWeight="bold"
        color="white"
        textAlign="center"
      >
        {language.certificate_title}
      </Text>
      <Text
        position="absolute"
        display="inline-block"
        top="52%"
        left="50%"
        transform="translate(-50%, 0);"
        fontSize="clamp(1rem, 2.55cqw, 44px)"
        color="black"
      >
        {traineeName}
      </Text>
      <Text
        position="absolute"
        display="inline-block"
        top="63%"
        left="50%"
        transform="translate(-50%, 0);"
        fontSize="clamp(0.5rem, 1.35cqw, 22px)"
        color="black"
        minWidth="70%"
        textAlign="center"
      >
        {renderInnerHtml(language.certificate_desc)}
      </Text>
      <Text
        position="absolute"
        display="inline-block"
        top="75%"
        left="50%"
        transform="translate(-50%, 0);"
        fontSize="clamp(0.5rem, 1.5cqw, 26px)"
        fontWeight="bold"
        color="black"
      >
        {currentDateFormatted}
      </Text>
    </>
  );
});
